//#region IMPORT
import React, { useEffect } from 'react';
import M_TBM_BASIC_06 from './M_TBM_BASIC_06';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
import { closeLoading, showLoading } from '../../../Reducer/LoadingReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';

//#endregion

function M_TBM_BASIC_06F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate(); // 네비게이션을 위한 훅
  const { userInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보

  //#endregion
  useBackStack({
    type: 'sheet',
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEnd' })),
  });

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    dispatch(showLoading());
    try {
      SaveLogic1();
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  //#region 조회
  //#endregion
  //#region 저장
  // tbm 참석자 저장 로직
  const SaveLogic1 = async () => {
    dispatch(showLoading());

    let saveData = [];
    try {
      saveData.push({
        procedureName: 'SP_M10605_U1',
        _tbmCd: Commons.EncryptAES(props.tbmCdRef.current) || '', // TBM코드
        _userid: userInfo.userid, // 참석자ID
        _completeYn: Commons.EncryptAES('Y') || 'Y', // TBM완료여부
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          const data = result?.data;

          if (!data) {
            throw new Error('서버에서 응답이 없습니다.');
          }

          if (data.type === 'Error') {
            throw new Error(data.message || '에러가 발생했습니다.');
          } else {
            // setSnackbar({
            //   open: true,
            //   type: 'success',
            //   message:
            //     lanList.length === 0
            //       ? '저장되었습니다.'
            //       : lanList.find(
            //           (f) =>
            //             f.lanType !== 'MENU' && f.lanId === 'ItHasBeenSaved'
            //         )?.lanNm || '저장되었습니다.',
            // });
            // navigate('/M10701', { state: { tbmCd: props.tbmCdRef.current } });
            // props.setActiveStep(0);
          }
        });
      }
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  //#endregion
  //#region 삭제
  //#endregion
  //#region 나머지 함수
  const Complete = () => {
    dispatch(CommonActions.setActiveStep(0));
    navigate('/M_PPE', { state: { tbmCd: props.tbmCdRef.current } });
  };
  //#endregion

  return (
    <M_TBM_BASIC_06
      check={props.check}
      setCheck={props.setCheck}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      // 함수
      SaveLogic1={SaveLogic1}
      TbmEnd={props.TbmEnd}
      Complete={Complete}
    />
  );
}

export default M_TBM_BASIC_06F;
